<template>
  <div class="contact">
    <banner banner="contact-banner" />
    <div class="contact-box">
      <div class="section">
        <div class="column">
          <h2>Contact Way</h2>
        </div>
        <div class="tab-menu">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.regionalOfficeEn"
              :name="index + ''"
              v-for="(item, index) in regionalListRes"
              :key="index"
            >
              <el-table :data="tableData" style="width: 100%" v-if="isPc">
                <el-table-column prop="office" label="office" width="160">
                </el-table-column>
                <el-table-column prop="phoneEn" label="phone" width="220">
                </el-table-column>
                <el-table-column prop="faxEn" label="fax" width="220">
                </el-table-column>
                <el-table-column
                  prop="addressEn"
                  label="address"
                ></el-table-column>
              </el-table>
              <div v-if="!isPc">
                <div class="contact-item" v-for="item in tableData" :key="item">
                  <h3>{{ item.office }}</h3>
                  <div class="info flex-row">
                    <span>phone:</span><span>{{ item.phone }}</span>
                  </div>
                  <div class="info flex-row">
                    <span>fax:</span><span>{{ item.fax }}</span>
                  </div>
                  <div class="info flex-row">
                    <span>address:</span><span>{{ item.address }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="contact-tips flex-col">
          <h3>
            If you suspect that you have encountered counterfeit KARON ECO-VALVE
            products, please contact us in time!
          </h3>
          <span>phone:{{ contactInfo2.joinPhone }}</span>
          <span>email:{{ contactInfo2.joinEmail }}</span>
        </div>
      </div>
      <div class="contact-bottom flex-col">
        <img src="@/assets/images/contact02.png" class="bg" />
        <div class="section justify-between items-center">
          <div class="join-us flex-col">
            <h3>Join Us</h3>
            <p>Recruitment hotline:{{ contactInfo.joinPhone }}</p>
            <p>Email:{{ contactInfo.joinEmail }}</p>
            <p>Address:{{ contactInfo.joinAddress }}</p>
          </div>
          <div class="more items-center justify-end little_hand">
            more jobs
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../common/banner.vue";
import {
  getRegionalList,
  getOfficeList,
  getJoin,
} from "@/assets/api/contact.js";

import { mapState } from "vuex";

export default {
  name: "contact",
  components: {
    banner,
  },
  data() {
    return {
      activeName: "0",
      tableData: [],
      regionalListRes: [],
      contactInfo: {},
      contactInfo2:{}
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getRegionalList({
      orderByColumn: "orderNum",
      isAsc: "desc",
    }).then((res) => {
      // console.log(res.data);
      this.regionalListRes = res.data.data.rows.map((item) => {
        return item;
      });
      this.init();
    });
    getJoin({
      type: 1,
    }).then((res) => {
      console.log(res.data);
      this.contactInfo = res.data.data;
    });
    getJoin({
      type: 2,
    }).then((res) => {
      console.log(res.data);
      this.contactInfo2 = res.data.data;
    });
  },
  methods: {
    init() {
      getOfficeList({
        orderByColumn: "orderNum",
        isAsc: "desc",
        regionalOfficeId:
          this.regionalListRes[this.activeName].regionalOfficeId,
        pageNum: 1,
        pageSize: 100,
      }).then((res) => {
        this.tableData = res.data.data.rows.map((item) => {
          item.phoneEn = item.phoneEn || item.phone;
          item.faxEn = item.faxEn || item.fax;
          item.addressEn = item.addressEn || item.address;
          return item;
        });
        // console.log(res.data);
      });
    },
    handleClick(tab, event) {
      this.activeName = tab.index;
      this.init();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.section {
  width: 1000px;
  margin: auto;
  position: relative;
}
.column {
  padding-top: 60px;
  margin-bottom: 24px;

  h2 {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #2c2c2e;
    line-height: 42px;
  }
}
.more {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
  .svg-icon {
    width: 32px;
    height: 16px;
    margin-left: 8px;
  }
}
.contact-box {
  .contact-tips {
    margin-top: 24px;
    h3 {
      font-size: 18px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #2c2c2e;
      line-height: 24px;
      margin-bottom: 16px;
    }
    span {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #2c2c2e;
      line-height: 22px;
      margin-top: 8px;
    }
  }
  .contact-bottom {
    margin-top: 70px;
    position: relative;
    .bg {
      width: 100%;
      height: 420px;
      object-fit: cover;
    }
    .section {
      position: absolute;
      top: -30px;
      left: 0;
      right: 0;
      background: rgba($color: #005bac, $alpha: 0.96);
      padding: 48px 80px;
      box-sizing: border-box;
      h3 {
        font-size: 36px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 47px;
        margin-bottom: 16px;
      }
      p {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 22px;
        margin-top: 8px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .section {
    width: 100%;
    padding: 0 20px;
  }
  .column {
    padding-top: 40px;
    h2 {
      font-size: 24px;
      line-height: 31px;
    }
  }
  .contact-box {
    .contact-item {
      padding: 16px 0;
      border-bottom: 1px solid #e5e5ea;
      h3 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 20px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 700;
        margin-bottom: 12px;
      }
      .info {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 400;
        margin-top: 4px;
        span:first-child {
          white-space: nowrap;
        }
      }
    }
    .contact-bottom {
      margin-top: 200px;
      position: relative;
      .bg {
        width: 100%;
        height: 315px;
        object-fit: cover;
      }
      .section {
        flex-direction: column;
        align-items: flex-start;
        width: auto;
        margin: 0 20px;
        top: -50%;
        padding: 60px 0 60px 16px;
        h3 {
          margin-bottom: 24px;
        }
        .more {
          margin-top: 40px;
        }
      }
    }
  }
}
</style>
<style>
.el-tabs__nav-wrap::after {
  content: none;
}
.el-tabs__item {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #2c2c2e;
  line-height: 28px;
  padding: 8px 16px !important;
  background: #f2f2f7;
  border-radius: 24px;
  height: auto;
  margin-right: 8px;
}
.el-tabs__item:hover {
  background: #005bac;
  color: #ffffff;
}
.el-tabs__active-bar {
  display: none;
}
.el-tabs__item.is-active {
  background: #005bac;
  color: #ffffff;
}
.el-table thead {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #2c2c2e;
  line-height: 19px;
}
.el-table thead th.el-table__cell {
  background: #f8f8fa;
}
.el-table th.el-table__cell > .cell {
  padding: 0 16px;
}
.el-table .cell {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #2c2c2e;
  line-height: 22px;
  padding: 0 16px;
}
</style>



// WEBPACK FOOTER //
// src/en/contact/index.vue